var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 59V51H44.0273L31.9091 41.2V47H28V35H29.9545L51.4545 47.1V33H61.2273L71 45V59H66.1136C66.1136 60.6667 65.5436 62.0833 64.4034 63.25C63.2633 64.4167 61.8788 65 60.25 65C58.6212 65 57.2367 64.4167 56.0966 63.25C54.9564 62.0833 54.3864 60.6667 54.3864 59H43.6364C43.6364 60.6667 43.0663 62.0833 41.9261 63.25C40.786 64.4167 39.4015 65 37.7727 65C36.1439 65 34.7595 64.4167 33.6193 63.25C32.4792 62.0833 31.9091 60.6667 31.9091 59H28ZM37.7727 62C38.6197 62 39.3201 61.7167 39.8739 61.15C40.4277 60.5833 40.7045 59.8667 40.7045 59C40.7045 58.1333 40.4277 57.4167 39.8739 56.85C39.3201 56.2833 38.6197 56 37.7727 56C36.9258 56 36.2254 56.2833 35.6716 56.85C35.1178 57.4167 34.8409 58.1333 34.8409 59C34.8409 59.8667 35.1178 60.5833 35.6716 61.15C36.2254 61.7167 36.9258 62 37.7727 62ZM60.25 62C61.097 62 61.7974 61.7167 62.3511 61.15C62.9049 60.5833 63.1818 59.8667 63.1818 59C63.1818 58.1333 62.9049 57.4167 62.3511 56.85C61.7974 56.2833 61.097 56 60.25 56C59.403 56 58.7027 56.2833 58.1489 56.85C57.5951 57.4167 57.3182 58.1333 57.3182 59C57.3182 59.8667 57.5951 60.5833 58.1489 61.15C58.7027 61.7167 59.403 62 60.25 62ZM55.3636 45H65.9182L59.3705 37H55.3636V45Z",
    fill: "#3958A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49 1.5C75.2335 1.5 96.5 22.7665 96.5 49C96.5 75.2335 75.2335 96.5 49 96.5C22.7665 96.5 1.5 75.2335 1.5 49C1.5 22.7665 22.7665 1.5 49 1.5Z",
    stroke: "#3958A5",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThree);
export default __webpack_public_path__ + "static/media/icon-three.2c1a7eda38d150a22e91403fbb2754ee.svg";
export { ForwardRef as ReactComponent };